import React from 'react';

const OrderNotes = ({ formik }) => {
    return (
        <div className="checkout-step">
            <div className="step-header">
                <h3>Order Notes</h3>
            </div>
            <div className="step-content">
                <div className="form-group">
                    <textarea
                        className="form-control"
                        placeholder="Additional information about your order"
                        rows="4"
                        name="additionalInfo"
                        value={formik.values.additionalInfo}
                        onChange={formik.handleChange}
                    ></textarea>
                </div>
            </div>
        </div>
    );
};

export default OrderNotes; 